<script>
import TableFooter from 'dashboard/components/widgets/TableFooter.vue';
import TableHeaderCell from 'dashboard/components/widgets/TableHeaderCell.vue';
import CommissionItem from './CommissionItem.vue';
import Spinner from 'shared/components/Spinner.vue';
export default {
  name: 'CommissionTable',
  components: {
    CommissionItem,
    TableFooter,
    Spinner,
    TableHeaderCell,
  },
  props: {
    commissonReports: {
      type: Array,
      default: () => [],
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 25,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['pageChange'],
  data() {
    return {
      pageNo: 1,
    };
  },
  computed: {
    shouldShowFooter() {
      return this.currentPage === 1
        ? this.totalCount > this.pageSize
        : this.commissonReports.length > 0;
    },
  },
  methods: {
    onPageChange(page) {
      this.$emit('pageChange', page);
    },
  },
};
</script>

<template>
  <div>
    <div
      class="min-w-full shadow outline-1 outline outline-n-container rounded-xl bg-n-solid-2 p-6"
    >
      <div
        class="grid content-center h-12 grid-cols-12 gap-4 px-6 py-0 bg-n-slate-2 rounded-md"
      >
        <TableHeaderCell :span="3" label="Order No" />
        <TableHeaderCell :span="3" label="Order Amount" />
        <TableHeaderCell :span="2" label="Commission Rate" />
        <TableHeaderCell
          :span="2"
          label="Commission Amount"
          class="whitespace-nowrap"
        />
        <TableHeaderCell :span="2" label="" />
      </div>

      <div v-if="isLoading" class="flex items-center justify-center h-32">
        <Spinner />
        <span>{{ 'Loading...' }}</span>
      </div>
      <div v-else-if="commissonReports.length > 0">
        <CommissionItem
          v-for="item in commissonReports"
          :key="item.id"
          :order-no="item.order_no"
          :order-amount="item.order_amount"
          :commission-rate="item.commission_rate"
          :commission-amount="item.amount"
        />
      </div>
      <div v-else class="flex items-center justify-center h-32">
        {{ 'No order commissions' }}
      </div>
    </div>
    <TableFooter
      v-if="shouldShowFooter"
      :current-page="currentPage"
      :total-count="totalCount"
      :page-size="pageSize"
      @page-change="onPageChange"
    />
  </div>
</template>
